// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__6BEFM","footer":"ModalInfo_footer__2RWjj"};